import { useTranslation } from 'react-i18next'

import ExploreIcon from '@wwt/shared/assets/icons/outline/explore.svg'

import { DialogClose } from '@/shared/ui/Dialog.tsx'
import { DropdownMenuItem } from '@/shared/ui/DropdownMenu'
import { NestedMenuItem } from '@/shared/ui/NestedMenu'

import { useMyTravels } from '../../lib/useMyTravels'

export const MyTravelsItem = () => {
	const { t } = useTranslation('header')

	const { handleSelect } = useMyTravels()

	return (
		<DropdownMenuItem
			data-wwt-id="header__user-my-travels--button"
			onSelect={handleSelect}
		>
			<ExploreIcon />

			{t('accountMenu.items.myTravels')}
		</DropdownMenuItem>
	)
}

export const MyTravelsNestedItem = () => {
	const { t } = useTranslation('header')

	const { handleSelect } = useMyTravels()

	return (
		<DialogClose asChild>
			<NestedMenuItem
				data-wwt-id="header__user-my-travels--button"
				onClick={handleSelect}
			>
				<ExploreIcon />

				{t('accountMenu.items.myTravels')}
			</NestedMenuItem>
		</DialogClose>
	)
}
